import _objectWithoutProperties from "/mnt/c/Users/Yeray/game-workspace/migasgame/frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["__reqid"];
import { generateRandomToken } from './random-token-generator';
import intentErrors from './intent-errors';
import pkgInfo from '../package.json';
/**
 * Create transport handler for a given window|iframe and establish communication channel.
 * @param {Window} targetWindow - Transport window|iframe reference.
 * @param {Boolean} ephemeral - If set to true, automatically closes the window opened after receiving the response.
 */

function TransportHandler(targetWindow) {
  var _this = this;

  var ephemeral = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  this.windowHandler = targetWindow;
  this.ephemeral = !!ephemeral;
  this.isLoaded = false;
  this.pendingRequests = {};
  this.preprocessRequestParams = null;
  this.onLoaded = new Promise(function (resolve, reject) {
    return _this.onLoadedCallback = resolve;
  }).then(function () {
    return _this;
  });
  this.messageHandler = this.messageHandler.bind(this);
  window.addEventListener('message', this.messageHandler, false);
}

TransportHandler.prototype = {
  isLoaded: false,
  markLoaded: function markLoaded() {
    var onLoadedCallback = this.onLoadedCallback;

    if (onLoadedCallback) {
      this.onLoadedCallback = null;
      this.isLoaded = true;
      onLoadedCallback();
    }
  },

  /**
   * Handler for incoming communication messages processing.
   * @param {Object} data - Received data.
   */
  messageHandler: function messageHandler(_ref) {
    var data = _ref.data;

    if (data.albedo) {
      var version = data.albedo.version; //TODO: check version compatibility

      return this.markLoaded();
    }

    if (data.albedoIntentResult) {
      var _data$albedoIntentRes = data.albedoIntentResult,
          __reqid = _data$albedoIntentRes.__reqid,
          result = _objectWithoutProperties(_data$albedoIntentRes, _excluded),
          pending = this.pendingRequests[__reqid];

      if (pending) {
        delete this.pendingRequests[__reqid];
        pending(result.error, result);

        if (this.ephemeral) {
          window.removeEventListener('message', this.messageHandler, false);
          this.windowHandler.close();
        }
      }
    }
  },

  /**
   * Handler for the transport window close event.
   */
  transportCloseHandler: function transportCloseHandler() {
    for (var key in this.pendingRequests) {
      if (this.pendingRequests.hasOwnProperty(key)) {
        var pending = this.pendingRequests[key];
        delete this.pendingRequests[key];
        pending(intentErrors.actionRejectedByUser);
      }
    }
  },

  /**
   * Request intent confirmation using current transport.
   * @param {Object} params - Intent request params.
   * @return {Promise}
   */
  postMessage: function postMessage(params) {
    var _this2 = this;

    var nonce = generateRandomToken();
    return new Promise(function (resolve, reject) {
      _this2.onLoaded.then(function () {
        _this2.pendingRequests[nonce] = function (err, data) {
          return err ? reject(err) : resolve(data);
        };

        params = Object.assign({
          __reqid: nonce,
          __albedo_intent_version: pkgInfo.version
        }, params);

        if (_this2.preprocessRequestParams) {
          params = _this2.preprocessRequestParams(params);
        }

        _this2.windowHandler.postMessage(params, '*');
      });
    });
  }
};
export default TransportHandler;